import React, { useEffect } from 'react';
import { Dayjs } from 'dayjs';
import { HintText, Text, Stack } from '@mos-cat/ds';

import OutageBlock from '../common/OutageBlock';
import { convertDateToFriendlyFormat, getPluralizedDiffInDays } from '../../../../helpers/date';
import { STATS_EVENTS, sendStats } from '../../../../helpers/sendStats';

type Props = {
  dateFrom: Dayjs;
  dateTo: Dayjs;
};

// typograf-enable
export default function OutagePassed({ dateFrom, dateTo }: Props) {
  const formattedDateFrom = convertDateToFriendlyFormat(dateFrom);
  const formattedDateTo = convertDateToFriendlyFormat(dateTo);
  const pluralizedDiffInDays = getPluralizedDiffInDays(dateFrom, dateTo);
  const daysCountHint = pluralizedDiffInDays ? ` (${pluralizedDiffInDays})` : '';
  const period = `${formattedDateFrom} — ${formattedDateTo}`;

  useEffect(function sendStatsOnMount() {
    sendStats(STATS_EVENTS.OUTAGE_PASSED);
  }, []);

  return (
    <OutageBlock heading="В вашем доме плановое отключение горячей воды уже было">
      <Stack mt="sp-12">
        <HintText>Период отключения</HintText>
        <Text>
          {period}
          {daysCountHint}
        </Text>
      </Stack>
    </OutageBlock>
  );
}
